import script from "./Reservations.vue?vue&type=script&setup=true&lang=js"
export * from "./Reservations.vue?vue&type=script&setup=true&lang=js"

import "./Reservations.vue?vue&type=style&index=0&id=3cd2f4e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd2f4e1"]])

export default __exports__